const isValidType = (cellType: string, dataType: string, required: boolean): boolean => {
  if (cellType === 'null' && required) {
    return false;
  }
  if (cellType === 'null' && !required) {
    return true;
  }
  if (dataType !== 'string') {
    if (dataType !== cellType) {
      return false;
    }
  }

  return true;
};

export default isValidType;
